import React from 'react';
import SubordinateActions from './SubordinateActions';
import { User } from '../api/types'; 
import { Link, useNavigate } from 'react-router-dom';

interface Props {
  subordinates: User[];
  onActionComplete: () => void; 
}


const SubordinatesTable: React.FC<Props> = ({ subordinates, onActionComplete }) => {

  const navigate = useNavigate();
const handleProfileClick = (userId: number) => {
    navigate(`/admin/profile/${userId}`);
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Username</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Current Role</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Parent</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Profile</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {subordinates.map((subordinate) => (
            <tr key={subordinate.id}>
              <td className="px-6 py-4 whitespace-nowrap">{subordinate.username}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                  subordinate.role === 'ADMIN' ? 'bg-blue-100 text-blue-800' :
                  subordinate.role === 'MANAGER' ? 'bg-indigo-100 text-indigo-800' :
                  subordinate.role === 'TEAM_LEADER' ? 'bg-purple-100 text-purple-800' :
                  subordinate.role === 'AGENT' ? 'bg-green-100 text-green-800' :
                  'bg-gray-100 text-gray-800'
                }`}>
                  {subordinate.role || 'Unassigned'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                  subordinate.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {subordinate.active ? 'Active' : 'Inactive'}
                </span>
                
              </td>
              <td className="px-6 py-4 whitespace-nowrap">{subordinate.parent?.username || 'N/A'}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <SubordinateActions
                  subordinate={subordinate}
                  onActionComplete={onActionComplete}
                />
              </td>
             <Link
      to={`/admin/profile/${subordinate.id}`}
      className="text-blue-600 hover:text-blue-800 p-5 -ml-12 rounded-fit transition duration-150 flex items-center justify-center" // p-0 for better alignment, added flex
      title="View Profile" 
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5" // h-5 w-5 icon size theek karne ke liye
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        />
      </svg>
    </Link>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubordinatesTable;